import { GetHttp, PostHttp } from "./fetch";
import { useEffect } from "react";
import Massage from "../components/design/Massage";


export default function FetchMassage ({url, text, data, fun, setClose, setMassage}) {
    useEffect(() => {
        let funSend = data ? PostHttp : GetHttp;

        funSend(url, data).then((resolve) => {

            if (resolve === 422) {
                setMassage({open: true, text: 'שגיאה באחד מהנתונים'});
            } else if (resolve === 400 || resolve === 404) {
                setMassage({open: true, text: 'שגיאה'});
            } else {
                fun(resolve);
            }
        })
        .catch((reject) => {
            setMassage({open: true, text: 'שגיאה !! נסה שוב בעוד כמה דקות'});
        })

    }, [])

    return (
        <Massage 
        text={text} 
        setClose={setClose} 
        animation={text === "" ? false : true}
        />
    )
}